"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderSpecialties = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const tooltip_1 = __importDefault(require("@kyruus/tooltip"));
const constants_1 = require("../common/util/constants");
const MapProviderCard_styles_1 = require("./MapProviderCard.styles");
const ProviderSpecialties = ({ specialties, id }) => {
    if (specialties.length === 0)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(MapProviderCard_styles_1.ProviderSpecialtiesContainer, { "data-testid": `map-provider-specialties-${id}` },
        react_1.default.createElement(MapProviderCard_styles_1.ProviderSpecialtiesContent, { "data-testid": `map-provider-specialties-compact-${id}` },
            react_1.default.createElement(MapProviderCard_styles_1.ProviderCompactFirstSpecialty, null, specialties[0]),
            specialties.length > 1 && (react_1.default.createElement(tooltip_1.default, { title: specialties.slice(1).join(', ') },
                react_1.default.createElement(MapProviderCard_styles_1.ProviderSpecialtiesMoreAnchor, { role: "tooltip", "data-testid": `map-provider-specialties-more-tooltip-anchor-${id}` },
                    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.miniMoreSpecialties))))))));
};
exports.ProviderSpecialties = ProviderSpecialties;
//# sourceMappingURL=ProviderSpecialties.js.map